/* Auto-generated, do not edit */
import React from 'react';

interface Props {
  size?: number | string;
  width?: number | string;
  height?: number | string;
  fill?: string;
}

function Avatar_icn_avatar14(props: Props) {
    const { size = 14, width = size, height = size, fill = '' } = props;
    return (
      <svg viewBox="0 0 24 24" fill="#27A2A8" width={ `${ width }px` } height={ `${ height }px` } ><path d="M20 21h-2v-6c0-.737.604-1.083 1.091-1.361.497-.285.909-.545.909-.839C20 4.635 13.877 4 12 4s-8 .635-8 8.8c0 .294.412.554.909.839C5.396 13.917 6 14.263 6 15v6H4v-5.578l-.084-.048C3.246 14.991 2 14.277 2 12.8 2 4.828 7.387 2 12 2s10 2.828 10 10.8c0 1.478-1.246 2.191-1.916 2.574l-.084.048V21z"/><circle cx="8.5" cy="10.5" r="2.5"/><circle cx="15.5" cy="10.5" r="2.5"/><path d="M15 18a1 1 0 0 1-1-1v-2c0-1.103-.897-2-2-2s-2 .897-2 2v2a1 1 0 1 1-2 0v-2c0-2.206 1.794-4 4-4s4 1.794 4 4v2a1 1 0 0 1-1 1z"/><circle cx="12" cy="14" r="1"/><path d="M12 3c-4.557 0-9 2.8-9 9.8 0 1.4 2 1.762 2 2.2v6h14v-6c0-.438 2-.8 2-2.2 0-7-4.443-9.8-9-9.8z" opacity=".3"/></svg>
  );
}

export default Avatar_icn_avatar14;
